<template>
  <v-container
    grid-list-xs
    fluid
  >
    <v-card class="elevation-1 pa-3 login-card">
      <v-card-text>
        <div class="layout column align-center">
          <h2 class="flex my-2 primary--text">
            Resultado da votação
          </h2>
          <h3 class="flex primary--text">
            Conselhos de cultura
          </h3>
        </div>
        <v-card v-if="!ativarPeriodoVotacao || (perfil && perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR)">
          <v-tabs
            v-model="aba"
            dark
            color="primary"
            centered
          >
          <v-btn color="success" round @click="gerarRelatorioExcel" v-if="perfil && perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR">Gerar relatório Excel</v-btn>
          <v-spacer v-if="perfil && perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR"></v-spacer>
            <v-tabs-slider color="white" />
            <v-tab
              v-for="regiao in regioes"
              :key="regiao.coRegiao"
              :href="'#tab-' + regiao.coRegiao"
            >
              {{regiao.nomeRegiao}}
            </v-tab>

            <v-tabs-items
              v-model="aba"
            >
              <v-tab-item
                v-for="regiao in regioes" 
                :key="regiao.coRegiao"
                :value="`tab-${regiao.coRegiao}`"
              >
                <votacao-resultado-component
                  :coRegiao="regiao.coRegiao"
                  :nomeRegiao="regiao.nomeRegiao"
                />
              </v-tab-item>
            </v-tabs-items>
            <v-spacer v-if="perfil && perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR"></v-spacer>
            <v-spacer v-if="perfil && perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR"></v-spacer>
          </v-tabs>
        </v-card>
        <v-card v-else>
          <v-alert
            :value="true"
            icon="warning"
            color="yellow lighten-3"
            class="black--text"
          >
            Atenção! O resultado da votação será publicado à partir do dia 02/12/2022
          </v-alert>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { regioes } from '../../localidade/utils/codigosRegiao';
import { mapActions, mapGetters } from 'vuex';

import VotacaoResultadoComponent from './components/VotacaoResultadoComponent';
import codigosPerfil from '../../conta/utils/codigosPerfil';

export default {
  name: 'VotacaoResultado',
  components: {
    VotacaoResultadoComponent
  },
  data: () => ({
    regioes,
    codigosPerfil,
    aba: 'tab-1',
  }),
  computed: {
    ...mapGetters({
      ativarPeriodoVotacao: 'fase/ativarPeriodoVotacao',
      fases: 'fase/fases',
      perfil: 'conta/perfil'
    })
  },
  methods: {
    ...mapActions({
      gerarRelatorioExcel: 'votacao/gerarRelatorioExcelVotacao'
    })
  },
};
</script>
